(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('feasibilityVerify', {
            parent: 'account',
            url: '/feasibilityverify/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/feasibility/verify/finish/feasibility.verify.finish.html',
                    controller: 'FeasibilityVerifyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('feasibilityVerify');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
